import React from 'react';
import { Fade } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import JDC from '../images/JDC.jpeg';
import JDC2 from '../images/JDC2.jpeg';
import jdc3 from '../images/jdc3.jpeg';

// Slideshow container styles
const slideshowContainerStyle = {
  width: '100%',
  maxWidth: '1200px',
  margin: '0 auto',
  position: 'relative',
  borderRadius: '8px',
  overflow: 'hidden',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
};

// Individual slide styles
const divStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  height: '80vh',
  minHeight: '400px',
  position: 'relative',
};

// Caption styles
const captionStyle = {
  position: 'absolute',
  bottom: '20px',
  left: '20px',
  color: '#fff',
  fontSize: '1.5rem',
  fontWeight: 'bold',
  backgroundColor: 'rgba(0, 0, 0, 0.6)',
  padding: '10px 20px',
  borderRadius: '4px',
  textTransform: 'uppercase',
  letterSpacing: '1px',
};

// Custom navigation arrow styles
const arrowStyle = {
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  padding: '10px',
  borderRadius: '50%',
  cursor: 'pointer',
  transition: 'background-color 0.3s',
};

// Slide images array
const slideImages = [
  {
    url: JDC,
    caption: 'Innovate',
    alt: 'First slide showcasing innovation',
  },
  {
    url: JDC2,
    caption: 'Inspire',
    alt: 'Second slide showcasing inspiration',
  },
  {
    url: jdc3,
    caption: 'Impact',
    alt: 'Third slide showcasing impact',
  },
];

// Fade properties for smoother transitions
const fadeProperties = {
  duration: 5000, // 5 seconds per slide
  transitionDuration: 1000, // 1 second fade transition
  infinite: true,
  indicators: true, // Show dots
  arrows: true, // Show arrows
  pauseOnHover: true,
};

// Responsive styles via CSS
const responsiveStyles = `
  @media (max-width: 768px) {
    .slide-container {
      height: 40vh;
      min-height: 250px;
    }
    .caption {
      font-size: 1rem;
      padding: 8px 15px;
    }
    .react-slideshow-container .nav {
      width: 30px;
      height: 30px;
    }
  }
  @media (max-width: 480px) {
    .slide-container {
      height: 30vh;
      min-height: 200px;
    }
    .caption {
      font-size: 0.9rem;
    }
  }
  .react-slideshow-container .nav:hover {
    background-color: rgba(0, 0, 0, 0.8);
  }
  .react-slideshow-container .indicators .each-slideshow-indicator {
    background-color: rgba(255, 255, 255, 0.5);
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin: 0 5px;
  }
  .react-slideshow-container .indicators .each-slideshow-indicator.active {
    background-color: #fff;
  }
`;

const Slideshow = () => {
  return (
    <div className="slide-container" style={slideshowContainerStyle}>
      <style>{responsiveStyles}</style>
      <Fade {...fadeProperties}>
        {slideImages.map((slideImage, index) => (
          <div key={index} aria-label={`Slide ${index + 1}`}>
            <div
              style={{
                ...divStyle,
                backgroundImage: `url(${slideImage.url})`,
              }}
              role="img"
              aria-label={slideImage.alt}
            >
              <span className="caption" style={captionStyle}>
                {slideImage.caption}
              </span>
            </div>
          </div>
        ))}
      </Fade>
    </div>
  );
};

export default Slideshow;